import { upload } from './request'
import * as XLSX from 'xlsx/xlsx.mjs'
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import CryptoJS from 'crypto-js';

export default {
  chooseFile({ filter = '', multiple = false }) {
    return new Promise((resolve) => {
      const fileEl = document.createElement('input')
      fileEl.type = 'file'
      fileEl.accept = filter
      if (multiple) fileEl.multiple = true
      fileEl.onchange = (e) => {
        const files = e.target.files
        if (multiple) {
          resolve(files)
        } else {
          resolve(files[0])
        }
      }
      fileEl.click()
    })
  },
  chooseAndUploadFile(filter) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const file = await this.chooseFile({ filter })
        const url = await upload(file)
        resolve({url, name: file.name})
      })
    })
  },
  chooseAndUploadFiles(filter) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const files = await this.chooseFile({ filter, multiple: true })
        const result = []
        for (let i = 0; i < files.length; i++) {
          const url = await upload(files[i])
          result.push(url)
        }
        resolve(result)
      })
    })
  },
  getExcelData(file, format) {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsBinaryString(file);//以二进制的方式读取
      reader.onload = ev =>{
        let data = ev.target.result;
        let workbook = XLSX.read(data, { type: "binary" });//解析二进制格式数据
        let worksheet = workbook.Sheets[workbook.SheetNames[0]];//获取第一个Sheet
        let result = XLSX.utils.sheet_to_json(worksheet);//json数据格式

        const res = []
        for (const r of result) {
          const obj = {}
          for (const xk of Object.keys(format)) {
            obj[format[xk]] = r[xk] ? r[xk] : obj[format[xk]]
            if (format[xk] == 'idnumber') {
              obj[format[xk]] = obj[format[xk]] ? obj[format[xk]].replaceAll(/\s/g, '') : ''
            }
          }
          res.push(obj)
        }
        resolve(res)
      }
    })
  },
  buildZipTree(folder, file) {
    if (file.directory) {
      const newFolder = folder.folder(file.name);
      file.content.forEach(child => {
        this.buildZipTree(newFolder, child);
      });
    } else {
      folder.file(file.name, file.content);
    }
  },
  async zipFile(zipFiles, fileName) {
    const zip = new JSZip();
    zipFiles.forEach(child => {
      this.buildZipTree(zip, child);
    });
    zip.generateAsync({ type: "blob" }).then(content => {
      saveAs(content, fileName);
      console.log("ZIP文件已生成");
    });
  },
  uuid() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
  },
  md5(str) {
    return CryptoJS.MD5(str).toString(CryptoJS.enc.Hex);
  }
}